export default "__VITE_ASSET__A1X8wbsj__"